export const RESET_PROFILES = "RESET_PROFILES";
export const RESET_PROFILE = "RESET_PROFILE";
export const RESET_ERROR = "RESET_ERROR";

export const GET_PROFILES_CLIENT = "GET_PROFILES_CLIENT";
export const GET_PROFILES_BACKOFFICE = "GET_PROFILES_BACKOFFICE";
export const SET_PROFILES = "SET_PROFILES";

export const API_ERROR = "PROFILES_API_ERROR";

export const GET_PROFILE = "GET_PROFILE";
export const SET_PROFILE = "SET_PROFILE";

export const EDIT_PROFILE = "EDIT_PROFILE";
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS";

export const CREATE_PROFILE = "CREATE_PROFILE";
export const CREATE_PROFILE_SUCCESS = "CREATE_PROFILE_SUCCESS";

export const DELETE_PROFILE = "DELETE_PROFILE";
export const DELETE_PROFILE_SUCCESS = "DELETE_PROFILE_SUCCESS";
